import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useCreateAccount } from '../../data/useInternalAdmin';

interface CreateAccountDialogProps {
  open: boolean;
  onClose: () => void;
}

const CreateAccountDialog: React.FC<CreateAccountDialogProps> = ({
  open,
  onClose,
}) => {
  const [name, setName] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const createAccount = useCreateAccount();

  const handleSubmit = () => {
    setError(null);
    createAccount.mutate(
      { name, title: title || undefined },
      {
        onSuccess: () => {
          setName('');
          setTitle('');
          onClose();
        },
        onError: (err: any) => {
          const detail =
            err?.response?.data?.detail || 'Failed to create account';
          setError(detail);
        },
      },
    );
  };

  const handleClose = () => {
    setName('');
    setTitle('');
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Account</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          autoFocus
          label="Account Name"
          helperText="URL-safe slug (e.g. acme-corp)"
          fullWidth
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 1, mb: 2 }}
        />
        <TextField
          label="Display Title"
          helperText="Human-readable name (optional)"
          fullWidth
          size="small"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!name || createAccount.isPending}
        >
          {createAccount.isPending ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAccountDialog;
